import { createFileRoute } from "@tanstack/react-router";
import { TipTap } from "@/components/text-editor/tiptap.tsx";

export const Route = createFileRoute("/_auth/editor/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="m-4">
      <TipTap />
    </div>
  );
}
